import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["columns", "data", "pageSizeOptions", "pageSize", "minRows", "style", "className", "showPagination", "onRowClick", "loading", "isLoaded", "useInfiniteScroll", "EmptyPlaceholder", "getTrProps", "getTrGroupProps", "SubComponent", "getTbodyProps", "subRowsKey", "borderedTable"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTable from 'react-table';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _constant from 'lodash/constant';
import '@tekion/tekion-styles-next/scss/component.scss';
import colors from '@tekion/tekion-styles-next/scss/variables.scss';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Spinner from '../SpinnerComponent';
import { getScaleAdjustedSize } from '../../utils/general';
import 'react-table/react-table.css';
import { getExpandedFromValues } from '../tableInputField/TableInputField.helpers';
import TablePagination from './TablePagination';
import FontIcon from '../../atoms/FontIcon';
import TableTokenPagination from '../../organisms/TableTokenPagination';

// Helpers
import { makeGetTrProps } from './helpers/rowHelpers';
import styles from './table.module.scss';
import Content from '../../atoms/Content';
var EmptyPlaceholderComponent = function EmptyPlaceholderComponent() {
  return /*#__PURE__*/React.createElement(Content, {
    className: "no-data"
  }, " ", __('No rows found'));
};
var Loading = function Loading(_ref) {
  var loading = _ref.loading;
  return loading && /*#__PURE__*/React.createElement("div", {
    className: styles.spinnerWrap
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "large"
  }));
};
var defaultGetTableRowKey = function defaultGetTableRowKey(keyVal, rowGroupProps) {
  var tableTrGroupNestingPath = _get(rowGroupProps, 'nestingPath');
  return "".concat(tableTrGroupNestingPath, "_").concat(keyVal);
};
var getTableProps = _constant({
  sectiontype: 'table-section'
});
var getProps = _constant({
  sectiontype: 'container-section'
});
var getTheadProps = _constant({
  sectiontype: 'section-header'
});
var BaseTable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BaseTable, _React$PureComponent);
  var _super = _createSuper(BaseTable);
  function BaseTable(props) {
    var _this;
    _classCallCheck(this, BaseTable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getTrGroupProps", function (tableProps, rowGroupProps) {
      var _this$props = _this.props,
        tableTrGroupKey = _this$props.tableTrGroupKey,
        getTableRowKey = _this$props.getTableRowKey,
        getTrGroupProps = _this$props.getTrGroupProps;
      var tableTrGroupKeyValue = _get(rowGroupProps, "original.".concat(tableTrGroupKey), EMPTY_STRING);
      var key = getTableRowKey(tableTrGroupKeyValue, rowGroupProps);
      var index = _get(rowGroupProps, 'index', '');
      var id = "automation_selector_tr_row_".concat(index);
      return _objectSpread({
        key: key,
        id: id
      }, getTrGroupProps(tableProps, rowGroupProps));
    });
    _defineProperty(_assertThisInitialized(_this), "getRowProps", function (state, rowInfo) {
      var _this$props2 = _this.props,
        onRowClick = _this$props2.onRowClick,
        rowHeight = _this$props2.rowHeight,
        rowStyle = _this$props2.rowStyle,
        showRowHoverColor = _this$props2.showRowHoverColor,
        getRowClassName = _this$props2.getRowClassName;
      var isRowDataPresent = rowInfo && rowInfo.row;
      var key = _get(rowInfo, 'original.tableRowKey');
      var id = _get(rowInfo, 'index');
      if (isRowDataPresent) {
        return {
          onClick: function onClick() {
            onRowClick(rowInfo);
          },
          style: _objectSpread({
            height: getScaleAdjustedSize(rowHeight)
          }, rowStyle),
          rowInfo: rowInfo,
          className: classNames({
            rowHoverColor: showRowHoverColor
          }, getRowClassName(state, rowInfo)),
          key: key,
          id: id
        };
      }
      return {
        style: _objectSpread({
          height: getScaleAdjustedSize(rowHeight)
        }, rowStyle),
        key: key
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getTheadTrProps", function () {
      var _this$props3 = _this.props,
        tableHeaderHeight = _this$props3.tableHeaderHeight,
        platformInfo = _this$props3.platformInfo,
        headerStyle = _this$props3.headerStyle;
      var computedStyle = {
        height: getScaleAdjustedSize(tableHeaderHeight)
      };
      var osName = _get(platformInfo, 'osName', '');
      if (osName === 'Windows') {
        computedStyle.paddingRight = '2rem';
        computedStyle.backgroundColor = colors.glitter;
      }
      return {
        style: _objectSpread(_objectSpread({}, headerStyle), computedStyle)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getTheadThProps", function (state, rowInfo, column) {
      var _column$resizable = column.resizable,
        resizable = _column$resizable === void 0 ? true : _column$resizable,
        headerClassName = column.headerClassName;
      return {
        headerClassName: resizable ? headerClassName : "".concat(headerClassName, " ").concat(styles.thStyle)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getPaginationComponent", function () {
      var _this$props4 = _this.props,
        totalNumberOfEntries = _this$props4.totalNumberOfEntries,
        currentPage = _this$props4.currentPage,
        pageSize = _this$props4.pageSize,
        changePage = _this$props4.changePage,
        pagerSize = _this$props4.pagerSize,
        loading = _this$props4.loading,
        pageSizeOptions = _this$props4.pageSizeOptions,
        paginationClass = _this$props4.paginationClass,
        totalNumberOfPages = _this$props4.totalNumberOfPages,
        displayFirstLast = _this$props4.displayFirstLast,
        tokenPagination = _this$props4.tokenPagination,
        nextPageToken = _this$props4.nextPageToken,
        canSetResultsPerPage = _this$props4.canSetResultsPerPage;
      if (tokenPagination) {
        return /*#__PURE__*/React.createElement(TableTokenPagination, {
          displayFirstLast: displayFirstLast,
          isLoading: loading,
          currentPage: currentPage,
          changePage: changePage,
          resultsPerPage: pageSize,
          resultsPerPageOptions: pageSizeOptions,
          className: paginationClass,
          nextPageToken: nextPageToken,
          canSetResultsPerPage: canSetResultsPerPage
        });
      }
      return /*#__PURE__*/React.createElement(TablePagination, {
        displayFirstLast: displayFirstLast,
        isLoading: loading,
        pagerSize: pagerSize,
        totalNumberOfEntries: totalNumberOfEntries,
        currentPage: currentPage,
        changePage: changePage,
        resultsPerPage: pageSize,
        resultsPerPageOptions: pageSizeOptions,
        className: paginationClass,
        totalNumberOfPages: totalNumberOfPages,
        canSetResultsPerPage: canSetResultsPerPage
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onExpanderClick", function (cellInfo) {
      return function (event) {
        var _this$props5 = _this.props,
          onExpanderClick = _this$props5.onExpanderClick,
          overrideDefaultExpanderClick = _this$props5.overrideDefaultExpanderClick;
        if (overrideDefaultExpanderClick) {
          event.stopPropagation();
          onExpanderClick(cellInfo);
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderExpander", defaultMemoize(function (cellInfo) {
      var _classNames;
      var isExpanded = _get(cellInfo, 'isExpanded', false);
      var _this$props6 = _this.props,
        pivotIconClassName = _this$props6.pivotIconClassName,
        checkExpanderVisibility = _this$props6.checkExpanderVisibility;
      var hideExpander = checkExpanderVisibility(cellInfo);
      return /*#__PURE__*/React.createElement(FontIcon, {
        className: "inline-block",
        onClick: _this.onExpanderClick(cellInfo)
      }, "icon-caret-down ".concat(classNames(styles.pivotIcon, pivotIconClassName, (_classNames = {}, _defineProperty(_classNames, styles.isExpanded, isExpanded), _defineProperty(_classNames, styles.isHidden, hideExpander), _classNames))));
    }));
    _defineProperty(_assertThisInitialized(_this), "subComponentWrapper", function (params) {
      var _this$props7 = _this.props,
        SubComponent = _this$props7.SubComponent,
        subComponentWrapperClassName = _this$props7.subComponentWrapperClassName;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(styles.subComp, subComponentWrapperClassName)
      }, SubComponent(params));
    });
    _defineProperty(_assertThisInitialized(_this), "getExpandedProps", function () {
      var _this$props8 = _this.props,
        data = _this$props8.data,
        subRowsKey = _this$props8.subRowsKey;
      if (!subRowsKey) return EMPTY_OBJECT;
      var expanded = getExpandedFromValues(data, subRowsKey);
      if (_isEmpty(expanded)) {
        return EMPTY_OBJECT;
      }
      return {
        expanded: expanded
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandedChange", function (newExpanded, index, event) {
      var onExpandedChange = _this.props.onExpandedChange;
      var getResolvedState = _get(_assertThisInitialized(_this), 'reactTable.current.getResolvedState', _noop);
      var _ref2 = getResolvedState() || EMPTY_OBJECT,
        sortedData = _ref2.sortedData;
      onExpandedChange(newExpanded, index, event, sortedData);
    });
    _this.getTrProps = makeGetTrProps(props.getTrProps, _this.getRowProps);
    _this.reactTable = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(BaseTable, [{
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
        columns = _this$props9.columns,
        data = _this$props9.data,
        pageSizeOptions = _this$props9.pageSizeOptions,
        pageSize = _this$props9.pageSize,
        minRows = _this$props9.minRows,
        style = _this$props9.style,
        className = _this$props9.className,
        showPagination = _this$props9.showPagination,
        onRowClick = _this$props9.onRowClick,
        loading = _this$props9.loading,
        isLoaded = _this$props9.isLoaded,
        useInfiniteScroll = _this$props9.useInfiniteScroll,
        EmptyPlaceholder = _this$props9.EmptyPlaceholder,
        getTrProps = _this$props9.getTrProps,
        getTrGroupProps = _this$props9.getTrGroupProps,
        SubComponent = _this$props9.SubComponent,
        getTbodyProps = _this$props9.getTbodyProps,
        subRowsKey = _this$props9.subRowsKey,
        borderedTable = _this$props9.borderedTable,
        rest = _objectWithoutProperties(_this$props9, _excluded);
      var scrollLoading = useInfiniteScroll && isLoaded && loading;
      return /*#__PURE__*/React.createElement(ReactTable, _extends({
        data: data,
        loading: loading && !scrollLoading,
        scrollLoading: scrollLoading,
        columns: columns,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        minRows: minRows,
        getTrProps: this.getTrProps,
        getTableProps: getTableProps,
        getProps: getProps,
        showPagination: showPagination,
        PaginationComponent: this.getPaginationComponent,
        className: classNames(className, _defineProperty({}, styles.tableBordered, borderedTable)),
        ref: this.reactTable // This ref is required to get the internal data of the table which helps us in using checkboxTable. Do not change the ref name.
        ,
        style: style // To send table height and other styles
        ,
        onRowClick: onRowClick,
        getTheadTrProps: this.getTheadTrProps,
        getTheadThProps: this.getTheadThProps,
        getTheadProps: getTheadProps,
        getTrGroupProps: this.getTrGroupProps,
        NoDataComponent: EmptyPlaceholder,
        LoadingComponent: Loading,
        showRowHoverColor: true,
        SubComponent: SubComponent && this.subComponentWrapper,
        ExpanderComponent: this.renderExpander,
        getTbodyProps: getTbodyProps,
        subRowsKey: subRowsKey
      }, this.getExpandedProps(), rest, {
        onExpandedChange: this.handleExpandedChange
      }));
    }
  }]);
  return BaseTable;
}(React.PureComponent);
_defineProperty(BaseTable, "propTypes", {
  totalNumberOfEntries: PropTypes.number,
  currentPage: PropTypes.number,
  pagerSize: PropTypes.number,
  resultsPerPage: PropTypes.number,
  changePage: PropTypes.func,
  onRowClick: PropTypes.func,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  minRows: PropTypes.number.isRequired,
  style: PropTypes.any,
  className: PropTypes.any,
  showPagination: PropTypes.bool,
  rowStyle: PropTypes.object,
  rowHeight: PropTypes.number,
  tableHeaderHeight: PropTypes.number,
  isChecked: PropTypes.func,
  loading: PropTypes.bool,
  showRowHoverColor: PropTypes.bool,
  EmptyPlaceholder: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  pageSize: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  getTrProps: PropTypes.func,
  getTbodyProps: PropTypes.func,
  SubComponent: PropTypes.func,
  platformInfo: PropTypes.object,
  subRowsKey: PropTypes.string,
  pivotIconClassName: PropTypes.string,
  paginationClass: PropTypes.string,
  tableTrGroupKey: PropTypes.string,
  getTableRowKey: PropTypes.func,
  borderedTable: PropTypes.bool,
  headerStyle: PropTypes.any,
  totalNumberOfPages: PropTypes.number,
  onExpandedChange: PropTypes.func,
  getTrGroupProps: PropTypes.func,
  useInfiniteScroll: PropTypes.bool,
  checkExpanderVisibility: PropTypes.func,
  tokenPagination: PropTypes.bool,
  nextPageToken: PropTypes.string,
  onExpanderClick: PropTypes.func,
  overrideDefaultExpanderClick: PropTypes.bool,
  subComponentWrapperClassName: PropTypes.string,
  getRowClassName: PropTypes.func,
  canSetResultsPerPage: PropTypes.bool
});
_defineProperty(BaseTable, "defaultProps", {
  onRowClick: _noop,
  pagerSize: 10,
  currentPage: 1,
  resultsPerPage: 10,
  style: EMPTY_OBJECT,
  className: EMPTY_STRING,
  showPagination: false,
  rowStyle: EMPTY_OBJECT,
  rowHeight: 30,
  tableHeaderHeight: 40,
  isChecked: _noop,
  loading: false,
  EmptyPlaceholder: EmptyPlaceholderComponent,
  changePage: _noop,
  showRowHoverColor: true,
  totalNumberOfEntries: 10,
  getTrProps: _noop,
  getTbodyProps: undefined,
  SubComponent: null,
  platformInfo: EMPTY_OBJECT,
  subRowsKey: EMPTY_STRING,
  pivotIconClassName: EMPTY_STRING,
  paginationClass: EMPTY_STRING,
  tableTrGroupKey: EMPTY_STRING,
  getTableRowKey: defaultGetTableRowKey,
  borderedTable: true,
  headerStyle: EMPTY_OBJECT,
  totalNumberOfPages: 0,
  onExpandedChange: _noop,
  useInfiniteScroll: false,
  getTrGroupProps: _noop,
  checkExpanderVisibility: _constant(false),
  tokenPagination: false,
  nextPageToken: EMPTY_STRING,
  onExpanderClick: _noop,
  overrideDefaultExpanderClick: false,
  subComponentWrapperClassName: EMPTY_STRING,
  getRowClassName: _noop,
  canSetResultsPerPage: true
});
export default BaseTable;